import { HttpRequestStream } from '../utils/httpRequestStream';
import { post } from '../utils/http';
import { APIResponse } from '../types/api-response';
import { UserRegistrationDetails } from '../types/user-registration-details';
import { OrganisationRegistrationDetails } from '../types/organisation-registration-details';

export interface CheckExistingEmailPayload {
  email: string;
}

export interface CheckExistingEmailResponse {
  existing: boolean;
}

export type ExistingEmailChecker = HttpRequestStream<
  CheckExistingEmailPayload, 
  APIResponse<CheckExistingEmailResponse>
>;

export function createExistingEmailChecker() {
  return new HttpRequestStream<
    CheckExistingEmailPayload, 
    APIResponse<CheckExistingEmailResponse>
  >('1.0/auth/checkExistingEmail');
}

export interface GenerateVerificationCodeResponse {
  token: string;
}

export function generateVerificationCode(email: string): Promise<APIResponse<GenerateVerificationCodeResponse>> {
  return post('1.0/auth/generateVerificationCode', { email });
}

export function confirmVerificationCode(email: string, code: string, token: string): Promise<APIResponse> {
  return post('1.0/auth/confirmVerificationCode', { email, code, token });
}

export interface RegisterUserPayload extends UserRegistrationDetails {
  token: string;
  code: string;
}

export interface RegisterUserResponse {
  id: string;
  name: string;
  email: string;
}

export function registerUser(details: RegisterUserPayload): Promise<APIResponse<RegisterUserResponse>> {
  return post('1.0/auth/createMember', details);
}

export interface CheckExistingDomainPayload {
  organisationDomain: string;
  token: string;
}

export interface CheckExistingDomainResponse {
  existing: boolean;
}

export type ExistingDomainChecker = HttpRequestStream<
  CheckExistingDomainPayload, 
  APIResponse<CheckExistingDomainResponse>
>;

export function createExistingDomainChecker() {
  return new HttpRequestStream<
    CheckExistingDomainPayload, 
    APIResponse<CheckExistingDomainResponse>
  >('1.0/auth/checkExistingDomain');
}

export interface RegisterOrganisationPayload extends OrganisationRegistrationDetails { 
  token: string;
}

export interface RegisterOrganisationResponse {
  organisation_id: string;
  organisation_name: string;
  organisation_domain: string;
}

export function registerOrganisation(details: RegisterOrganisationPayload): 
Promise<APIResponse<RegisterOrganisationResponse>> {
  return post('1.0/admin/createOrganisation', details);
}